/* 舊版登入頁曾寫入，已廢棄；載入時清除避免誤導除錯 */
try {
  if (typeof localStorage !== 'undefined') localStorage.removeItem('apiServerId')
} catch (e) {}

/**
 * API 基底由建置時環境變數與目前網址決定（登入頁不提供伺服器切換，全球同一套 UI）。
 *
 * 規則：
 * - VUE_APP_BASE_API 非空：base + VUE_APP_API_PREFIX（正式、預設 npm run dev 之本機後台）。
 * - VUE_APP_BASE_API 空且瀏覽器內：window.location.origin + prefix（Staging / Germany 等同源部署）。
 * - development 且 VUE_APP_USE_STAGING111_PROXY === 'true'：origin + /__staging111 + prefix（npm run dev:staging）。
 * - 瀏覽器網址為 staging.xrross-soc.com：強制同源 + /api/tokyo（避免誤部署 prod dist 時仍打 xrrossiot.com）。
 * - 瀏覽器網址為 de.xrross-soc.com：強制同源 + /api/de（避免誤部署 prod dist 跨域登入失敗）。
 * - 無 window（極少數）：後備東京 staging-admin 位址 + prefix。
 *
 * 本機連 111：請使用 `npm run dev:staging`（見 config/dev-staging.env.js）。
 */

const STAGING_FALLBACK_HOST = 'http://18.177.93.7:8089'

function envPrefix() {
  return process.env.VUE_APP_API_PREFIX || ''
}

export function getApiBase() {
  const base = (process.env.VUE_APP_BASE_API || '').trim()
  const prefix = envPrefix()

  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_USE_STAGING111_PROXY === 'true' &&
    typeof window !== 'undefined' &&
    window.location &&
    window.location.origin
  ) {
    const p = prefix || '/api/tokyo'
    return `${window.location.origin}/__staging111${p}`
  }

  // 公網 Staging：即便 bundle 誤用 prod（VUE_APP_BASE_API 指向正式站），仍走東京區同源 API
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname === 'staging.xrross-soc.com'
  ) {
    return `${window.location.origin}/api/tokyo`
  }

  // 東京生產：Gateway 僅掛 /api，誤部署 staging dist（/api/tokyo）時仍走正確前綴
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname === 'xrross-soc.com'
  ) {
    return `${window.location.origin}/api`
  }

  // 深圳生產：Gateway 僅掛 /api（非 /api/tokyo）；誤部署 staging dist 時仍走正確前綴
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname === 'xrrossiot.com'
  ) {
    return `${window.location.origin}/api`
  }

  // 德國生產：須走同源 /api/de；避免誤部署 prod dist（xrrossiot.com）導致跨域登入失敗
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname === 'de.xrross-soc.com'
  ) {
    return `${window.location.origin}/api/de`
  }

  if (base) {
    return base + prefix
  }

  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return `${window.location.origin}${prefix || ''}`
  }

  return STAGING_FALLBACK_HOST + (prefix || '/api/tokyo')
}

/**
 * Leo Brain WebSocket 目標 host（含埠）。
 * 本機頁面為 localhost / 127.0.0.1 且 API 指向本機 Gateway(20000) 或 dev server(8089–8091) 時，改直連 Background :10000，
 * 避免經 Gateway 升級 WS 時 query（token 等）未完整到達後端。
 */
export function resolveLeoBrainWsHost(apiBase) {
  const base = apiBase || ''
  const u = new URL(
    base,
    typeof window !== 'undefined' && window.location ? window.location.href : 'http://localhost'
  )
  const pageHost =
    typeof window !== 'undefined' && window.location && window.location.hostname
      ? window.location.hostname
      : ''
  const port = String(u.port || '')
  const localPage = pageHost === 'localhost' || pageHost === '127.0.0.1'
  const localApiPort = ['20000', '8089', '8090', '8091'].includes(port)
  if (localPage && localApiPort) {
    return `${pageHost}:10000`
  }
  return u.host
}



// WEBPACK FOOTER //
// ./src/config/apiServer.js